<div class="flex flex-col gap-4">
  <h4 class="text-xl font-semibold leading-tight text-lWhite">Enviar arquivo</h4>

  <l-file-upload-dropzone
    [status]="uploadStatus"
    [fileName]="shownFileName"
    [fileSizeLabel]="fileSizeLabel"
    [inputId]="webPageFileInputId"
    accept=".zip,.pdf,application/zip,application/x-zip-compressed,application/pdf"
    idleTitle="Selecione o arquivo para upload"
    [idleHints]="['Formatos aceitos: .zip, .pdf', '(máx 10mb)']"
    uploadedActions="delete-and-replace"
    [uploadedTitle]="uploadedTitle"
    (fileSelected)="onWebPageFileSelected($event)"
    (deleteClick)="onDeleteFile()"
  />
</div>
